import { render, staticRenderFns } from "./BundleDiscountLabelWithStore.vue?vue&type=template&id=27c05625&"
import script from "./BundleDiscountLabelWithStore.vue?vue&type=script&lang=ts&"
export * from "./BundleDiscountLabelWithStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports